// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"402":"13ffe681","467":"700660ab"}[chunkId] + ".chunk.js";
};